import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface SectionWrapperProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export function SectionWrapper({
  title,
  description,
  children,
  className,
}: SectionWrapperProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="border-b border-border/20 pb-1">
        <h3 className="text-sm font-medium text-foreground">{title}</h3>
        {description && (
          <p className="text-[10px] text-muted-foreground">{description}</p>
        )}
      </div>
      <div className="space-y-1">{children}</div>
    </div>
  );
}
